import {
  registerDecorator,
  ValidationOptions,
  ValidatorConstraint,
  ValidatorConstraintInterface,
} from 'class-validator';

@ValidatorConstraint()
export class IsValidSlotDTOConstraint implements ValidatorConstraintInterface {
  validate(slots: number[][]) {
    const slotsFiltered = slots.filter(slot => Array.isArray(slot) && slot.length === 2);

    if (slotsFiltered.length !== slots.length) {
      console.log('slotsFiltered is not equal to slots', slotsFiltered, slots);
      return false;
    }

    return true;
  }
}

export function IsValidSlot(validationOptions?: ValidationOptions) {
  return function (object: Record<string, any>, propertyName: string) {
    registerDecorator({
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      constraints: [],
      validator: IsValidSlotDTOConstraint,
    });
  };
}